import { render, staticRenderFns } from "./ListQuestions.vue?vue&type=template&id=fc85eccc&scoped=true"
import script from "./ListQuestions.vue?vue&type=script&lang=js"
export * from "./ListQuestions.vue?vue&type=script&lang=js"
import style0 from "./ListQuestions.vue?vue&type=style&index=0&id=fc85eccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc85eccc",
  null
  
)

export default component.exports